export const resetGenericError = () => dispatch => {
  dispatch({
    type: 'RESET_GENERIC_ERROR',
  });
};
